var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingStatus)?_c('div',{staticClass:"spinner-placeholder"},[_vm._v(" Loading "),_c('div',{staticClass:"loader quantum-spinner"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }